import { reduxKey } from './constants';
import { GallectionType } from '../types/gallection';
import { getGallectionStreamId, isGallectionManageable, getBrowseDeviationStreamId, getGallectionDeviationStreamId, getCustomDeviationSetStreamId, } from './helpers';
import { selectors } from '../Stream';
import { getDenormalizedDataEntityById, getDenormalizedDataEntitiesByIds, } from '../redux/entities/selectors';
import { galleryFolderSchema, collectionFolderSchema, } from '../redux/normalizr/schemas/folder';
import { MediaSourceType } from './types';
export var getMode = function (state) { return state[reduxKey].mode; };
export var getCurrentMediaSource = function (state) {
    return state[reduxKey].currentMediaSource;
};
export var getMediaSourceTypes = function (state) { return state[reduxKey].mediaSourceTypes; };
export var getWithMediaSourceSelector = function (state) {
    return state[reduxKey].withMediaSourceSelector;
};
export var getCurrentFolderId = function (state) { return state[reduxKey].currentFolderId; };
export var getCurrentSubfolderId = function (state) {
    return state[reduxKey].currentSubfolderId;
};
export var getSearchInput = function (state) { return state[reduxKey].searchInput; };
export var getSearchQuery = function (state) { return state[reduxKey].searchQuery; };
export var getAllowedDeviationTypes = function (state) {
    return state[reduxKey].allowedDeviationTypes;
};
export var getAllowGifs = function (state) { return state[reduxKey].allowGifs; };
export var getCurrentGallection = function (state) {
    var currentFolderId = getCurrentFolderId(state);
    return getGallectionById(state, currentFolderId);
};
export var getCurrentSubfolder = function (state) {
    var currentSubfolderId = getCurrentSubfolderId(state);
    return getGallectionById(state, currentSubfolderId);
};
export var getCurrentStreamId = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId;
    switch (mediaSource) {
        case MediaSourceType.GALLERY:
        case MediaSourceType.COLLECTION:
            var folderId = getCurrentFolderId(state);
            if (folderId) {
                var subfolderId = getCurrentSubfolderId(state);
                streamId = getGallectionDeviationStreamId(mediaSource, subfolderId || folderId);
            }
            else {
                streamId = getGallectionStreamId(mediaSource);
            }
            break;
        case MediaSourceType.BROWSE:
            streamId = getBrowseDeviationStreamId(getSearchQuery(state));
            break;
        case MediaSourceType.CUSTOM_SET:
            streamId = getCustomDeviationSetStreamId();
            break;
        default:
    }
    return streamId;
};
export var getGallectionById = function (state, folderId) {
    var currentMediaSource = getCurrentMediaSource(state);
    var gallectionSchema = currentMediaSource === GallectionType.COLLECTION
        ? collectionFolderSchema
        : galleryFolderSchema;
    return getDenormalizedDataEntityById(state, gallectionSchema, folderId);
};
export var getSelectionLimit = function (state) { return state[reduxKey].selectionLimit; };
export var getSelectedDeviationIds = function (state) {
    return state[reduxKey].selectedDeviationIds;
};
export var getAllGallections = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId = getGallectionStreamId(mediaSource);
    var topLevelGallectionIds = selectors.getItems(state, streamId);
    var allGallectionIds = [];
    topLevelGallectionIds.forEach(function (topLevelGallectionId) {
        var subfoldersStreamId = getGallectionStreamId(mediaSource, topLevelGallectionId);
        var subfoldersIds = selectors.getItems(state, subfoldersStreamId);
        allGallectionIds = allGallectionIds.concat([
            topLevelGallectionId
        ], subfoldersIds);
    });
    var gallectionSchema = mediaSource === MediaSourceType.COLLECTION
        ? collectionFolderSchema
        : galleryFolderSchema;
    var allGallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, allGallectionIds);
    return allGallections;
};
// TODO: rename to getTopLevelGallections when subfolders land
export var getGallections = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId = getGallectionStreamId(mediaSource);
    var gallectionSchema = mediaSource === MediaSourceType.COLLECTION
        ? collectionFolderSchema
        : galleryFolderSchema;
    var gallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, selectors.getItems(state, streamId));
    return gallections;
};
export var getFeaturedFolder = function (state) {
    return (getGallections(state) || []).find(function (folder) { return folder.name === 'Featured'; });
};
export var getCurrentGallectionSubfolders = function (state) {
    var currentGallection = getCurrentGallection(state);
    if (!currentGallection) {
        return [];
    }
    return getSubfoldersByParentId(state, currentGallection.folderId);
};
export var getSubfoldersByParentId = function (state, parentId) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId = getGallectionStreamId(mediaSource, parentId);
    var gallectionSchema = mediaSource === MediaSourceType.COLLECTION
        ? collectionFolderSchema
        : galleryFolderSchema;
    var gallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, selectors.getItems(state, streamId));
    return gallections;
};
export var getFirstManageableGallectionIndex = function (state) {
    var gallections = getGallections(state);
    if (!gallections) {
        return 0;
    }
    return gallections.findIndex(function (gallection) {
        return isGallectionManageable(gallection);
    });
};
export var getFileUploadsInfo = function (state) { return state[reduxKey].fileUploads; };
//# sourceMappingURL=selectors.js.map